/**
 * Reduce an array down to distinct values
 */
export const distinct = (value: any, index: number, self: any[]) => {
  return self.indexOf(value) === index;
}